import { IStep } from '../data/NewCampaignConstants';
import { IConfiguredDispatcher } from '../context/UseNewOffsiteCampaignContext';
import { ISelectOption } from '@salecycle/ui-component-library';
import { TFunction } from 'i18next';
import { IWrappedCampaign } from 'entities/campaign';

export const buildNewCampaignsPath = (siteId: string, path = ''): string => {
  return `/sites/${siteId}/campaigns/offsite/newcampaign` + path;
};

export const hasExistingActiveCartAbandonmentCampaign = (campaigns: IWrappedCampaign[]): boolean => {
  const campaignValues = campaigns.map(x => x.value);
  return campaignValues.findIndex(c => c.type) > -1;
};

export const arePreviousStepsValid = (validSteps: number[], currentStepNumber: number): boolean => {
  let valid = true;
  if (currentStepNumber !== 1) {
    for (let i = 1; i < currentStepNumber; i++) {
      if (!validSteps.includes(i)) {
        valid = false;
      }
    }
  }

  return valid;
};

export const redirectToLastValidStep = (
  allSteps: IStep[],
  validSteps: number[],
  push: (href: string) => void,
): void => {
  if (validSteps.length === 0) {
    push(buildNewCampaignsPath(allSteps[0].route));
  } else {
    const lastValidStep = Math.max(...validSteps);
    push(buildNewCampaignsPath(allSteps[lastValidStep].route));
  }
};

export const mapConfiguredDispatcherOptions = (
  configuredDispatchers: IConfiguredDispatcher[],
  t: TFunction,
): ISelectOption<string>[] => {
  return configuredDispatchers.map(x => {
    return {
      value: x.id,
      label: t(`integrations:names.${x.dispatcher}`),
    };
  });
};
